<template>
  <div>
    <label>{{ $t("trends.trendLineWords") }}</label>
    <v-autocomplete
      v-model="selected"
      :items="items"
      multiple
      clearable
      chips
      hide-details
      dense
      :item-text="getItemText"
      item-value="key"
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          small
          :input-value="data.selected"
          close
          @click:close="remove(data.item)"
        >
          {{ data.item.value }} ({{ $t(`data.${data.item.type}`) }})
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    remove(item) {
      const index = this.selected.indexOf(item.key);
      if (index >= 0) {
        const value = this.selected.slice();
        value.splice(index, 1);
        this.$emit("input", value);
      }
    },
    getItemText(item) {
      const value = item.value;
      const type = this.$t(`data.${item.type}`);
      const text = `${value} (${type})`;
      return text;
    }
  }
};
</script>

<style scoped></style>
